/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataEntriesResponseV3 } from '../models/data-entries-response-v-3';
import { DataEntryExcludingSearchIndex } from '../models/data-entry-excluding-search-index';
import { DataViewForAdminDtoWithRelations } from '../models/data-view-for-admin-dto-with-relations';
import { DataViews } from '../models/data-views';
import { DataViewsPermissionsDtoPartialExcludingIdModuleIsImplicitCreationInfoUpdateInfo } from '../models/data-views-permissions-dto-partial-excluding-id-module-is-implicit-creation-info-update-info';
import { DataViewsWithRelations } from '../models/data-views-with-relations';
import { EndUserViewDto } from '../models/end-user-view-dto';
import { EndUserViewsPermissionsDto } from '../models/end-user-views-permissions-dto';
import { EntryViewModel } from '../models/entry-view-model';
import { NewDataViews } from '../models/new-data-views';
import { DataViewsPermissionsDto } from '../models/data-views-permissions-dto';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataViewsControllerService extends DataBaseService {

  /**
   * Path part for operation dataViewsControllerFindDefaultView
   */
  static readonly DataViewsControllerFindDefaultViewPath = '/v1/entities/{entity}/default-view';

  /**
   * Get default view thats belongs to a specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDefaultView()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDefaultView$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataViewsWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindDefaultViewPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataViewsWithRelations>;
      })
    );
  }
  /**
   * Get default view thats belongs to a specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDefaultView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDefaultView(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataViewsWithRelations> {

    return this.findDefaultView$Response(params).pipe(
      map((r: StrictHttpResponse<DataViewsWithRelations>) => r.body as DataViewsWithRelations)
    );
  }

  /**
   * Path part for operation dataViewsControllerGetAViewForEndUser
   */
  static readonly DataViewsControllerGetAViewForEndUserPath = '/v1/entities/{entity}/entries/{entry}/view';

  /**
   * List entries that belongs to a specific public view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAViewForEndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAViewForEndUser$Response(params: {
    entity: string;
    entry: string;
    notificationId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<null | EntryViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerGetAViewForEndUserPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('entry', params.entry, {});
      rb.query('notificationId', params.notificationId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<null | EntryViewModel>;
      })
    );
  }
  /**
   * List entries that belongs to a specific public view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAViewForEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAViewForEndUser(params: {
    entity: string;
    entry: string;
    notificationId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<null | EntryViewModel> {

    return this.getAViewForEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<null | EntryViewModel>) => r.body as null | EntryViewModel)
    );
  }

  /**
   * Path part for operation dataViewsControllerCount
   */
  static readonly DataViewsControllerCountPath = '/v1/entities/{entity}/views/count';

  /**
   * Count views for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params: {
    entity: string;
    where?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('where', params.where, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count views for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params: {
    entity: string;
    where?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataViewsControllerEntriesCount
   */
  static readonly DataViewsControllerEntriesCountPath = '/v1/entities/{entity}/views/{id}/entries/count';

  /**
   * Count of entries that belongs to a specific view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entriesCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  entriesCount$Response(params: {
    entity: string;
    id: string;
    where?: any;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerEntriesCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.query('filterFirst', params.filterFirst, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count of entries that belongs to a specific view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entriesCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entriesCount(params: {
    entity: string;
    id: string;
    where?: any;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.entriesCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataViewsControllerExportEntries
   */
  static readonly DataViewsControllerExportEntriesPath = '/v1/entities/{entity}/views/{id}/entries/export/xlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntries$Response(params: {
    entity: string;
    id: string;
    fileName?: string;
    filter?: any;
    filterFirst?: any;
    include_virtual?: boolean;
    selectedColumns?: Array<string>;
    collectionId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerExportEntriesPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('fileName', params.fileName, {});
      rb.query('filter', params.filter, {});
      rb.query('filterFirst', params.filterFirst, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('selectedColumns', params.selectedColumns, {});
      rb.query('collectionId', params.collectionId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `exportEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportEntries(params: {
    entity: string;
    id: string;
    fileName?: string;
    filter?: any;
    filterFirst?: any;
    include_virtual?: boolean;
    selectedColumns?: Array<string>;
    collectionId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Blob> {

    return this.exportEntries$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindEntries
   */
  static readonly DataViewsControllerFindEntriesPath = '/v1/entities/{entity}/views/{id}/entries';

  /**
   * List entries that belongs to a specific view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntries$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindEntriesPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.query('filterFirst', params.filterFirst, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>;
      })
    );
  }
  /**
   * List entries that belongs to a specific view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntries(params: {
    entity: string;
    id: string;
    filter?: any;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntryExcludingSearchIndex>> {

    return this.findEntries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>) => r.body as Array<DataEntryExcludingSearchIndex>)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindRelationViewById
   */
  static readonly DataViewsControllerFindRelationViewByIdPath = '/v1/entities/{entity}/views/{id}/relation/{relationId}';

  /**
   * Get view by entity id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findRelationViewById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelationViewById$Response(params: {
    entity: string;
    id: string;
    relationId: string;
    relatedEntryId?: string;
    mainViewId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataViews>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindRelationViewByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.path('relationId', params.relationId, {});
      rb.query('relatedEntryId', params.relatedEntryId, {});
      rb.query('mainViewId', params.mainViewId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataViews>;
      })
    );
  }
  /**
   * Get view by entity id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findRelationViewById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findRelationViewById(params: {
    entity: string;
    id: string;
    relationId: string;
    relatedEntryId?: string;
    mainViewId?: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataViews> {

    return this.findRelationViewById$Response(params).pipe(
      map((r: StrictHttpResponse<DataViews>) => r.body as DataViews)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindById
   */
  static readonly DataViewsControllerFindByIdPath = '/v1/entities/{entity}/views/{id}';

  /**
   * Get view by entity id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataViewsPermissionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataViewsPermissionsDto>;
      })
    );
  }
  /**
   * Get view by entity id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataViewsPermissionsDto> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataViewsPermissionsDto>) => r.body as DataViewsPermissionsDto)
    );
  }

  /**
   * Path part for operation dataViewsControllerDeleteById
   */
  static readonly DataViewsControllerDeleteByIdPath = '/v1/entities/{entity}/views/{id}';

  /**
   * Delete specific view that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete specific view that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataViewsControllerUpdateById
   */
  static readonly DataViewsControllerUpdateByIdPath = '/v1/entities/{entity}/views/{id}';

  /**
   * Update specific view that belongs to an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataViewsPermissionsDtoPartialExcludingIdModuleIsImplicitCreationInfoUpdateInfo
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update specific view that belongs to an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataViewsPermissionsDtoPartialExcludingIdModuleIsImplicitCreationInfoUpdateInfo
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataViewsControllerFind
   */
  static readonly DataViewsControllerFindPath = '/v1/entities/{entity}/views';

  /**
   * List views for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    entity: string;
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataViewsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('filter', params.filter, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataViewsWithRelations>>;
      })
    );
  }
  /**
   * List views for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    entity: string;
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataViewsWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataViewsWithRelations>>) => r.body as Array<DataViewsWithRelations>)
    );
  }

  /**
   * Path part for operation dataViewsControllerCreate
   */
  static readonly DataViewsControllerCreatePath = '/v1/entities/{entity}/views';

  /**
   * Create views for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataViews
  }): Observable<StrictHttpResponse<DataViews>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerCreatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataViews>;
      })
    );
  }
  /**
   * Create views for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataViews
  }): Observable<DataViews> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataViews>) => r.body as DataViews)
    );
  }

  /**
   * Path part for operation dataViewsControllerCountAllForAdmin
   */
  static readonly DataViewsControllerCountAllForAdminPath = '/v1/views/admin/count';

  /**
   * Count all views in the system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countAllForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  countAllForAdmin$Response(params?: {
    where?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerCountAllForAdminPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count all views in the system
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `countAllForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countAllForAdmin(params?: {
    where?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.countAllForAdmin$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataViewsControllerGetViewsForAdmin
   */
  static readonly DataViewsControllerGetViewsForAdminPath = '/v1/views/admin';

  /**
   * List views for admin with entity and module info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getViewsForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getViewsForAdmin$Response(params?: {
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataViewForAdminDtoWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerGetViewsForAdminPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataViewForAdminDtoWithRelations>>;
      })
    );
  }
  /**
   * List views for admin with entity and module info
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getViewsForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getViewsForAdmin(params?: {
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataViewForAdminDtoWithRelations>> {

    return this.getViewsForAdmin$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataViewForAdminDtoWithRelations>>) => r.body as Array<DataViewForAdminDtoWithRelations>)
    );
  }

  /**
   * Path part for operation dataViewsControllerCanUserAccessView
   */
  static readonly DataViewsControllerCanUserAccessViewPath = '/v1/views/end-user/can-access/{id}';

  /**
   * returns whether the user can access this view or not
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `canUserAccessView()` instead.
   *
   * This method doesn't expect any request body.
   */
  canUserAccessView$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerCanUserAccessViewPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * returns whether the user can access this view or not
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `canUserAccessView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  canUserAccessView(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<boolean> {

    return this.canUserAccessView$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindViewPermissionsForEndUser
   */
  static readonly DataViewsControllerFindViewPermissionsForEndUserPath = '/v1/views/end-user/{id}/permissions';

  /**
   * Find view permissions by id without entity.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findViewPermissionsForEndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewPermissionsForEndUser$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<EndUserViewsPermissionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindViewPermissionsForEndUserPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EndUserViewsPermissionsDto>;
      })
    );
  }
  /**
   * Find view permissions by id without entity.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findViewPermissionsForEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewPermissionsForEndUser(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<EndUserViewsPermissionsDto> {

    return this.findViewPermissionsForEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<EndUserViewsPermissionsDto>) => r.body as EndUserViewsPermissionsDto)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindViewForEndUser
   */
  static readonly DataViewsControllerFindViewForEndUserPath = '/v1/views/end-user/{id}';

  /**
   * Find view by id without entity. This is used for end user to get the view info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findViewForEndUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewForEndUser$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataViews>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindViewForEndUserPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataViews>;
      })
    );
  }
  /**
   * Find view by id without entity. This is used for end user to get the view info
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findViewForEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewForEndUser(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataViews> {

    return this.findViewForEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<DataViews>) => r.body as DataViews)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindViewsInModuleCount
   */
  static readonly DataViewsControllerFindViewsInModuleCountPath = '/v1/views/{moduleId}/count';

  /**
   * List views related to specific module.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findViewsInModuleCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewsInModuleCount$Response(params: {
    moduleId: string;
    where?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindViewsInModuleCountPath, 'get');
    if (params) {
      rb.path('moduleId', params.moduleId, {});
      rb.query('where', params.where, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * List views related to specific module.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findViewsInModuleCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewsInModuleCount(params: {
    moduleId: string;
    where?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.findViewsInModuleCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindViewsInModule
   */
  static readonly DataViewsControllerFindViewsInModulePath = '/v1/views/{moduleId}';

  /**
   * List views related to specific module.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findViewsInModule()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewsInModule$Response(params: {
    moduleId: string;
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataViewsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindViewsInModulePath, 'get');
    if (params) {
      rb.path('moduleId', params.moduleId, {});
      rb.query('filter', params.filter, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataViewsWithRelations>>;
      })
    );
  }
  /**
   * List views related to specific module.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findViewsInModule$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewsInModule(params: {
    moduleId: string;
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataViewsWithRelations>> {

    return this.findViewsInModule$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataViewsWithRelations>>) => r.body as Array<DataViewsWithRelations>)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindAll
   */
  static readonly DataViewsControllerFindAllPath = '/v1/views';

  /**
   * List all views in the system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll$Response(params?: {
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataViewsWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindAllPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.query('includeImplicit', params.includeImplicit, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataViewsWithRelations>>;
      })
    );
  }
  /**
   * List all views in the system
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll(params?: {
    filter?: any;
    includeImplicit?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataViewsWithRelations>> {

    return this.findAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataViewsWithRelations>>) => r.body as Array<DataViewsWithRelations>)
    );
  }

  /**
   * Path part for operation dataViewsControllerEntriesCountV2
   */
  static readonly DataViewsControllerEntriesCountV2Path = '/v2/entities/{entity}/views/{id}/entries/count';

  /**
   * Count of entries that belongs to a specific view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entriesCountV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  entriesCountV2$Response(params: {
    entity: string;
    id: string;
    whereCriteria?: any;
    search?: string;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerEntriesCountV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('whereCriteria', params.whereCriteria, {});
      rb.query('search', params.search, {});
      rb.query('filterFirst', params.filterFirst, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count of entries that belongs to a specific view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `entriesCountV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entriesCountV2(params: {
    entity: string;
    id: string;
    whereCriteria?: any;
    search?: string;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.entriesCountV2$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindEntriesV2
   */
  static readonly DataViewsControllerFindEntriesV2Path = '/v2/entities/{entity}/views/{id}/entries';

  /**
   * List entries that belongs to a specific view
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntriesV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesV2$Response(params: {
    entity: string;
    id: string;
    filterCriteria?: any;
    search?: string;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindEntriesV2Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('filterFirst', params.filterFirst, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>;
      })
    );
  }
  /**
   * List entries that belongs to a specific view
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntriesV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesV2(params: {
    entity: string;
    id: string;
    filterCriteria?: any;
    search?: string;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntryExcludingSearchIndex>> {

    return this.findEntriesV2$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntryExcludingSearchIndex>>) => r.body as Array<DataEntryExcludingSearchIndex>)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindViewForEndUserWithRedirect
   */
  static readonly DataViewsControllerFindViewForEndUserWithRedirectPath = '/v2/views/end-user/{id}';

  /**
   * Find view with redirection rules without entity. This is used for end user to get the view info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findViewForEndUserWithRedirect()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewForEndUserWithRedirect$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<EndUserViewDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindViewForEndUserWithRedirectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EndUserViewDto>;
      })
    );
  }
  /**
   * Find view with redirection rules without entity. This is used for end user to get the view info
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findViewForEndUserWithRedirect$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findViewForEndUserWithRedirect(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<EndUserViewDto> {

    return this.findViewForEndUserWithRedirect$Response(params).pipe(
      map((r: StrictHttpResponse<EndUserViewDto>) => r.body as EndUserViewDto)
    );
  }

  /**
   * Path part for operation dataViewsControllerFindEntriesV3
   */
  static readonly DataViewsControllerFindEntriesV3Path = '/v3/entities/{entity}/views/{id}/entries';

  /**
   * List entries that belongs to a specific view with applied tags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findEntriesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesV3$Response(params: {
    entity: string;
    id: string;
    filterCriteria?: any;
    search?: string;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataEntriesResponseV3>> {

    const rb = new RequestBuilder(this.rootUrl, DataViewsControllerService.DataViewsControllerFindEntriesV3Path, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.query('search', params.search, {});
      rb.query('filterFirst', params.filterFirst, {});
      rb.query('include_virtual', params.include_virtual, {});
      rb.query('appliedQuickFilters', params.appliedQuickFilters, {});
      rb.query('appliedTagsFilters', params.appliedTagsFilters, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntriesResponseV3>;
      })
    );
  }
  /**
   * List entries that belongs to a specific view with applied tags
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findEntriesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findEntriesV3(params: {
    entity: string;
    id: string;
    filterCriteria?: any;
    search?: string;
    filterFirst?: any;
    include_virtual?: boolean;
    appliedQuickFilters?: Array<string>;
    appliedTagsFilters?: Array<string>;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataEntriesResponseV3> {

    return this.findEntriesV3$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntriesResponseV3>) => r.body as DataEntriesResponseV3)
    );
  }

}
